import { api } from '../config/api'
import moment from 'moment'
import { sanitizeFileName } from '../utils/file'

const schoolBaseEndpoint = '/FileApi'

export const uploadFile = ({ content, extension, attachment = false, filePath = null }, config) => {
  return api.post(`${schoolBaseEndpoint}/UploadAsBase64`, {
    content,
    fileType: extension,
    filePath,
    attachment
  }, config)
}

export const uploadKreaResourceFile = (
  {
    attachment = false,
    file,
    fileName,
    extension,
    schoolGroupId,
    schoolGroupName,
    contentId
  }, config) => {
  const hash = moment().format('YYYYMMDDHHmm')
  const fileNameWithHash = sanitizeFileName(fileName).replaceAll(' ', '_') + '_' + hash
  return api.post(`${schoolBaseEndpoint}/UploadAsBase64`, {
    content: file,
    fileType: extension,
    attachment,
    filePath: `Krea/${schoolGroupId}_${schoolGroupName.replaceAll(' ', '_')}/resources/${contentId}/${fileNameWithHash}`
  }, config)
}

export const uploadKreaContentFile = (
  {
    attachment = false,
    file,
    fileName,
    extension,
    schoolGroupId,
    schoolGroupName,
    contentId
  }, config) => {
  const hash = moment().format('YYYYMMDDHHmm')
  const fileNameWithHash = sanitizeFileName(fileName).replaceAll(' ', '_') + '_' + hash
  return api.post(`${schoolBaseEndpoint}/UploadAsBase64`, {
    content: file,
    fileType: extension,
    attachment,
    filePath: `Krea/${schoolGroupId}_${schoolGroupName.replaceAll(' ', '_')}/contents/${contentId}/${fileNameWithHash}`
  }, config)
}
